export default __webpack_public_path__ + "static/media/blue-marker-icon.2b3e1faf.png";